var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.265,
    height: 28.265,
    viewBox: "0 0 28.265 28.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "so-phone",
    d: "M29.394,24.26a2.979,2.979,0,0,1-.738,4.747,10.66,10.66,0,0,1-7.739.907c-6.9-1.738-16.83-11.663-18.568-18.568a10.66,10.66,0,0,1,.907-7.739A2.979,2.979,0,0,1,8,2.87L10.95,5.815a2.959,2.959,0,0,1,.629,3.29,5.479,5.479,0,0,1-1.1,1.656C7.111,14.13,18.135,25.155,21.5,21.784a5.479,5.479,0,0,1,1.658-1.1,2.956,2.956,0,0,1,3.29.629Z",
    transform: "translate(-1.998 -2.001)",
    fill: "#2772af"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoPhone);
export default __webpack_public_path__ + "static/media/so-phone.2acf2885cf1fe65552922023a478a90f.svg";
export { ForwardRef as ReactComponent };